import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Button, ButtonGroup, ButtonToolbar, Col, Row,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';

import NewEntityButton from './NewEntityButton';
import { TableScreenWithoutUpdate } from '../blocks/table_block';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';

const API_ENDPOINT = 'channels/?';

export default class ChannelsScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: {},
            results: [],
            previous: 'none',
            next: 'none',
            total_pages: 0,
            current_page: 1,
        };
        this.dragEndHandle = this.dragEndHandle.bind(this);
        this.moveItemUp = this.moveItemUp.bind(this);
        this.moveItemDown = this.moveItemDown.bind(this);
        this.removeItemHandler = this.removeItemHandler.bind(this);
        this.handleResultData = this.handleResultData.bind(this);
        this.refreshState = this.refreshState.bind(this);
        this.API_ENDPOINT_QS = '';
    }

    handleResultData(data) {
        this.setState({ results: data });
    }

    moveItemUp(event) {
        Fetcher(
            `${API_ENDPOINT.replace('?', '') + event.currentTarget.id}/`,
            'PUT',
            this.handleResultData,
            { id: event.currentTarget.id, priority: (parseInt(event.currentTarget.dataset.value) + 1) },
        );
    }

    moveItemDown(event) {
        Fetcher(
            `${API_ENDPOINT.replace('?', '') + event.currentTarget.id}/`,
            'PUT',
            this.handleResultData,
            { id: event.currentTarget.id, priority: (parseInt(event.currentTarget.dataset.value) - 1) },
        );
    }

    refreshState() {
        this.setState({ results: [] });
    }

    removeItemHandler(event) {
        if (window.confirm(`Внимание! Вы действительно хотите удалить ${event.currentTarget.dataset.name || ''}?`)) {
            Fetcher(`${API_ENDPOINT.replace('?', '') + event.currentTarget.id}/`, 'DELETE', this.refreshState);
        }
    }

    columns = [{
        Header: '',
        accessor: 'priority',
        maxWidth: 70,
        Cell: (row) => (
            <ButtonToolbar>
                <ButtonGroup>
                    <Button
                        size="sm"
                        variant="link"
                        id={row.row.id}
                        data-value={row.value}
                        onClick={this.moveItemUp}
                    >
                        <FontAwesomeIcon id={row.row.id} data-value={row.value} icon="arrow-up" />
                    </Button>
                    <Button
                        size="sm"
                        variant="link"
                        id={row.row.id}
                        data-value={row.value}
                        onClick={this.moveItemDown}
                    >
                        <FontAwesomeIcon id={row.row.id} data-value={row.value} icon="arrow-down" />
                    </Button>
                </ButtonGroup>
            </ButtonToolbar>
        ),

    }, {
        Header: 'Название',
        accessor: 'name',
    }, {
        Header: 'Slug',
        accessor: 'slug',
    }, {
        Header: 'Видимые',
        accessor: 'is_visible',
        Cell: (row) => (
            row.value ? <FontAwesomeIcon icon="check" />
                : <FontAwesomeIcon icon="minus" />
        ),
    }, {
        Header: '',
        accessor: 'id',
        maxWidth: 26,
        Cell: (row) => (
            <div>
                <Link to={`${PROJECT_PREFIX}/channels/${row.value}/edit`}>
                    <FontAwesomeIcon icon="pencil-alt" />
                </Link>

            </div>
        ),
    },
    {
        Header: '',
        accessor: 'id',
        maxWidth: 40,
        Cell: (row) => (
            <Button size="sm" variant="link" id={row.value} data-name={row.original.name} onClick={this.removeItemHandler}>
                <FontAwesomeIcon id={row.value} icon="trash" />
            </Button>
        ),
    },
    ];

    dragEndHandle(event) {
        const { draggableId } = event;
        const item_id = parseInt(draggableId.split('_')[0]);
        const src_priority = parseInt(draggableId.split('_')[1]);
        const src_pos = event.source.index;
        const dst_pos = event.destination.index;
        let new_priority = 0;

        if ((dst_pos - src_pos) > 0) {
            new_priority = src_priority - (dst_pos - src_pos);
        } else {
            new_priority = src_priority + (src_pos - dst_pos);
        }

        const uri = `${API_ENDPOINT.replace('?', '') + item_id}/`;
        Fetcher(
            uri,
            'PUT',
            this.handleResultData,
            ({
                id: item_id, priority: new_priority,
            }),
        );
    }

    render() {
        return (
            <div className="container-fluid">
                <Row className="mb-2">
                    <Col md={12}>
                        <NewEntityButton to="/channels/new" />
                    </Col>
                </Row>
                <TableScreenWithoutUpdate
                    draggable
                    draggableKey="priority"
                    handleDragEnd={this.dragEndHandle}
                    columns={this.columns}
                    endpoint={API_ENDPOINT + this.API_ENDPOINT_QS}
                    data={this.state}
                />
            </div>

        );
    }
}
